import React, { type ComponentProps } from 'react';
import { GlassView as ExpoGlassView } from 'expo-glass-effect';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Liquid Glass surface with the light appearance applied by default, so every
 * glass element in the design system reads the same regardless of the system
 * color scheme. Any prop can still be overridden by the caller.
 */
export const GlassView = (props: Props) => {
  return <ExpoGlassView colorScheme="light" {...props} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof ExpoGlassView>;
